export enum HistoryTaskType {
  task = 0,
  statusChange = 1,
}
